import { GroupOutlinedIcon, TableCell, NoRowsOverlay } from '@shared/components';
export default function ExamineeMonitorNoRowsOverlay() {
  return (
    <TableCell colSpan={12} sx={(theme) => ({ py: theme.spacing(4), width: '100%' })}>
      <NoRowsOverlay
        icon={GroupOutlinedIcon}
        title='ยังไม่มีรายชื่อผู้เข้าสอบ'
        slotProps={{
          wrapper: {
            disablePadding: true,
          },
          icon: {
            fontSize: 40,
          },
        }}
      />
    </TableCell>
  );
}
